import { FirestoreDocument } from './firestore-document';

export interface Student extends FirestoreDocument {
  name: string;
  gender: Gender;
  firstYear: number;
}

export enum Gender {
  Male,
  Female,
}
